/* eslint-disable @typescript-eslint/naming-convention -- special params here */

import { SafariObjectId } from '../../base-object/models/app/safari-object-base';

/**
 * Children of this class can be passed in all Api calls (loadObject/loadObjectList/createOrUpdateObject, etc)
 * and they will be carried throughout the entire chain of calls (effect/service/adapter) and will eventually
 * be roundtripped to the observer in context variable.
 *
 * Use this to
 *
 * a) Pass some additional information to the adapter that we can
 *    then query and do some custom logic (for example submission-adapter.ts)
 * b) Pass some information that's not part of the object, but  may be used by the observer to do
 *    something special when the object is loaded (for example InvoiceTemplatePreview observer)
 *
 * PS - This also used to be used to pass some additional/custom call context to services but we moved
 * away from custom services so this doesn't apply anymore.
 */
export class ApiCallContext<T = any> {
  // This is supposed to be added by the service when it executes the call to store info on
  // which exact URL it ended up calling.
  // Currently only used by dropdown to distinguish between different picklist options
  __url?: string;
  // This param doesn't seem to be in use but leaving alone for now
  __object?: T;
  // An optional parent ID that can be used to auto append parent IDs to the child object ID within a particular parent adapter
  // (delivery-portal-adapter.ts and delivery-portal-attachment-adapter for example)
  // NOTE: This is different than the old "__parentId" from crud.service - this is only used by fromApiId to automatically append
  // parentId to the child object ID (ex AttachmentMetadataAdapter.fromListModel)
  // It can also pass custom IDs to the child, like for example DeliveryPortalAdapter.fromGetModel
  __parentId?: SafariObjectId;
  // Query string parameters a single-object load (CrudService.retrieve) appends to its URL, for a GET that takes them
  // (e.g. my/features?names=...). List loads take theirs from CrudServiceParams instead. They aren't part of the
  // object's identity: loads of one id with different params share that id's store slot.
  __queryParams?: Record<string, string>;
}
